import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "trading-item trading-card card"
}
const _hoisted_2 = { class: "trading-card__row" }
const _hoisted_3 = { class: "trading-card__title" }
const _hoisted_4 = { class: "trading-card__row" }
const _hoisted_5 = { class: "trading-card__title" }
const _hoisted_6 = ["data-currency"]
const _hoisted_7 = { class: "trading-card__row" }
const _hoisted_8 = { class: "trading-card__icon trading-card__icon--green" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "trading-card__title" }, "Profit of trade is:", -1)
const _hoisted_10 = ["data-currency"]
const _hoisted_11 = {
  key: 1,
  class: "trading-card trading-current card"
}
const _hoisted_12 = { class: "trading-card__row" }
const _hoisted_13 = { class: "trading-card__icon trading-card__icon--black trading-card__icon--bg-orange" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "trading-card__title trading-current__title" }, "Opening new trade...", -1)
const _hoisted_15 = { class: "trading-card__row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "trading-card__icon" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "trading-card__title" }, "Actual price:", -1)
const _hoisted_18 = ["data-currency"]

import Icon from "@/components/Icon/Icon.vue";
import TradeEntity from "@/entities/TradeEntity";


export default /*#__PURE__*/_defineComponent({
  __name: 'TradingHistoryItem',
  props: {
    trade: {}
  },
  setup(__props: any) {


let {trade} = __props;



return (_ctx: any,_cache: any) => {
  return (_ctx.trade.status === 'closed')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("i", {
            class: _normalizeClass(["trading-card__icon", {
				 'trading-card__icon--green' : _ctx.trade.profit > 0,
				 'trading-card__icon--bg-green' : _ctx.trade.profit > 0,
				 'trading-card__icon--red' : _ctx.trade.profit < 0,
				 'trading-card__icon--bg-red' : _ctx.trade.profit < 0
			}])
          }, [
            _createVNode(Icon, {
              name: _ctx.trade.profit > 0 ? 'check' : 'close'
            }, null, 8, ["name"])
          ], 2),
          _createElementVNode("span", _hoisted_3, "Prediction was " + _toDisplayString(_ctx.trade.profit > 0 ? 'successful' : 'unsuccessful') + "!", 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("i", {
            class: _normalizeClass(["trading-card__icon", {
				'trading-card__icon--red' : _ctx.trade.course_opened! > _ctx.trade.course_closed!,
				'trading-card__icon--green' : _ctx.trade.course_opened! < _ctx.trade.course_closed!,
			}])
          }, [
            _createVNode(Icon, {
              name: _ctx.trade.course_opened! > _ctx.trade.course_closed! ? 'arrow-bottom-right' : 'arrow-top-right'
            }, null, 8, ["name"])
          ], 2),
          _createElementVNode("span", _hoisted_5, "Price is " + _toDisplayString(_ctx.trade.course_opened! > _ctx.trade.course_closed! ? 'DOWN' : 'UP'), 1),
          _createElementVNode("span", {
            class: "trading-card__value",
            "data-currency": `USDT/${_ctx.trade.currency.toUpperCase()}`
          }, "to " + _toDisplayString(_ctx.trade.course_closed!), 9, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("i", _hoisted_8, [
            _createVNode(Icon, { name: "long" })
          ]),
          _hoisted_9,
          _createElementVNode("span", {
            class: "trading-card__value",
            "data-currency": `USDT/${_ctx.trade.currency.toUpperCase()}`
          }, _toDisplayString((_ctx.trade.profit * 100).toFixed(2)) + " %", 9, _hoisted_10)
        ])
      ]))
    : (_ctx.trade.status === 'opened')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("i", _hoisted_13, [
              _createVNode(Icon, { name: "flag" })
            ]),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _hoisted_17,
            _createElementVNode("span", {
              class: "trading-card__value",
              "data-currency": `USDT/${_ctx.trade.currency.toUpperCase()}`
            }, _toDisplayString(_ctx.trade.course_opened!), 9, _hoisted_18)
          ])
        ]))
      : _createCommentVNode("", true)
}
}

})